<template>
  <div>
    <div class="f-inline-group">
      <legend
        :class="{ 'f-field__label--required' : isRequired }"
        class="f-field__label"
      >
        {{ $t(`fields.record.${fieldName}.label`) }}
      </legend>
      <div
        v-if="$te(`advancedsearch.fields.${fieldName}.description`)"
        class="f-field__tooltip"
      >
        <Tooltip>
          <p>
            {{ $t(`advancedsearch.fields.${fieldName}.description`) }}
          </p>
        </Tooltip>
      </div>
    </div>
    <div class="f-field">
      <div class="f-inline-group">
        <div class="f-field-advanced-search__controller-select">
          <select
            v-model="modelValue.option"
            class="f-field__input f-field__input--select"
            @change="$emit('change', modelValue)"
          >
            <option
              v-for="opt in ['any', 'none']"
              :key="fieldName + opt"
              :value="opt"
            >
              {{ $t(`advancedsearch.fields.enum.options.${opt}`) }}
            </option>
          </select>
        </div>
        <TagsField
          v-model="modelValue.value"
          :record-type="recordType"
          :field-name="fieldName"
          :validator-name="validatorName"
          :is-required="isRequired"
          :array="false"
          @change="$emit('change', modelValue)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Tooltip from '#src/components/utils/Tooltip.vue'
import TagsField from '#src/components/advanced-search/fields/TagsField.vue'

export default {
  components: {
    Tooltip,
    TagsField
  },
  props: {
    modelValue: {
      type: Object,
      required: true
    },
    recordType: {
      type: String,
      required: true
    },
    fieldName: {
      type: String,
      required: true
    },
    validatorName: {
      type: String,
      default: null
    },
    isRequired: {
      type: Boolean,
      default: false
    }
  },
  emits: ['change'],
  async created() {
    if (this.modelValue.value === null) {
      this.modelValue.value = []
    }
    if (this.modelValue.option === null) {
      this.modelValue.option = 'any'
    }
  }
}
</script>
